var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBadgeCheck = function SvgBadgeCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.442 2.916c.12.29.35.521.641.642l1.018.422a1.185 1.185 0 0 1 .642 1.549l-.421 1.017c-.12.29-.121.618 0 .908l.42 1.017a1.188 1.188 0 0 1-.641 1.55l-1.018.421c-.29.12-.521.35-.642.641l-.421 1.018a1.186 1.186 0 0 1-1.55.642l-1.017-.421c-.29-.12-.617-.12-.907 0l-1.018.421a1.186 1.186 0 0 1-1.548-.64l-.422-1.02c-.12-.29-.35-.52-.641-.641l-1.018-.422a1.186 1.186 0 0 1-.642-1.548l.421-1.018c.12-.29.12-.617 0-.907l-.421-1.019a1.186 1.186 0 0 1 .642-1.55l1.017-.421c.29-.12.521-.35.642-.64l.421-1.018a1.186 1.186 0 0 1 1.55-.642l1.017.421c.29.12.617.12.907 0l1.019-.42a1.186 1.186 0 0 1 1.549.641l.421 1.019v-.002Z",
    fill: "#2787F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.25 7 1.167 1.167 2.625-2.625",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBadgeCheck;